<template>
    <p :class="className">
        {{ content }}
    </p>
</template>

<script setup lang="ts">
import { IIssuesCardContent } from '../../types';

withDefaults(defineProps<IIssuesCardContent>(), {
    className: 'mb-0 text-body-2 mt-4'
});
</script>
